import PlaylistApi from "@/api/playlist/PlaylistApi";

const state = {
  selectedGroupId: 'all',
  //selectedGroupName: null,
  selectedGroupName: 'All Groups',
  currentPage: 1,
  selectedItems: [],
  selectedGroup: [],
  groupingCompleted: false,
  deleteStatus: false,
  modifyStatus: false,
};

const mutations = {
  setSelectedGroupId(state, groupId) {
    state.selectedGroupId = groupId;
  },
  setSelectedGroupName(state, groupName) {
    state.selectedGroupName = groupName;
  },
  setCurrentPage(state, page) {
    state.currentPage = page;
  },
  setSelectedItems(state, items) {
    state.selectedItems = items;
  },
  UPDATE_SELECTED_ITEMS(state, items) {
    state.selectedItems = items;
  },
  UPDATE_SELECTED_GROUP(state, group) {
    state.selectedGroup = group;
  },
  SET_GROUPING_COMPLETED(state, value) {
    state.groupingCompleted = value;
    console.log('SET_GROUPING_COMPLETED', state.groupingCompleted);
  },
  INVALIDATE_CACHE(state) {
    state.cachedPlaylists = {};
  },
  setDeleteStatus(state, status) {
    state.deleteStatus = status;
  },
  setModifyStatus(state, status) {
    state.modifyStatus = status;
  }
};

const actions = {
  updateSelectedGroupId({ commit, dispatch, state }, groupId) {
    commit('setSelectedGroupId', groupId);
    //console.log('store', groupId);
    const groupName = groupId === 'all' ? 'All Groups' : '';
    commit('setSelectedGroupName', groupName);
    if( groupName === 'all'){
      dispatch('reportDeleteStatus', true);
    }
  },
  reportDeleteStatus({ commit }, status) {
    commit('setDeleteStatus', status);
  },
  updateSelectedGroupName({ commit }, groupName) {
    commit('setSelectedGroupName', groupName);
  },
  updateCurrentPage({ commit }, page) {
    commit('setCurrentPage', page);
  },
  updateSelectedItems({ commit }, items) {
    commit('setSelectedItems', items);
  },
  reportModifyStatus({ commit }, status) {
    commit('setModifyStatus', status);
  },

  //그룹핑 -> 컴포넌트로 전달
  async grouping({ commit, state }, { assetIds, playlistIds }) {
    try {
      const response = await PlaylistApi.groupingAsset({ assetIds, playlistIds });
      if (response.status === '1') {
        commit('SET_GROUPING_COMPLETED', true);
        commit('UPDATE_SELECTED_ITEMS', []);
        commit('UPDATE_SELECTED_GROUP', []);
        commit('INVALIDATE_CACHE');
        setTimeout(() => {
          commit('SET_GROUPING_COMPLETED', false);
        }, 1000);
      }
    } catch (error) {
      console.error('error', error);
    }
  },
  //그룹에 노래넣기
  async addPlaylistToGroup({ commit, state }, { assetIds, groupId }) {
    try {
      const response = await PlaylistApi.addPlaylist({ assetIds, groupId });
      if (response.status === '1') {
        //console.log('성공');
        commit('SET_GROUPING_COMPLETED', true);
        //commit('setSelectedGroupId', groupId); 
        setTimeout(() => {
          commit('SET_GROUPING_COMPLETED', false);
        }, 1000);
      }
    } catch (error) {
      console.error('error', error);
    }
  }

};

const getters = {
  selectedItems: state => state.selectedItems,
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
